export default "__VITE_ASSET__BmaOJ5yi__"